import { Table } from 'antd';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { TableColumnsFilter } from 'shared/UI/UIKit/TableColumnsFilter';
import { TableFilter } from 'shared/UI/UIKit/TableFilter';
import { CreateEducationClass } from 'entities/education-class';
import { useEducationClassesTable } from '../model';
import { educationClassesFilterFields } from '../model/filter-fields';
import styles from './styles.module.scss';

export const EducationClassesTable = () => {
  const {
    state: { educationClasses, isLoading, pagination, allColumns, displayedColumns },
    methods: { onTableChange, onColumnsChange, onFilterChange },
  } = useEducationClassesTable();

  return (
    <>
      <AppFlex direction="row" justifyContent="flex-end" className={styles.controls}>
        <CreateEducationClass />
        <TableFilter
          fields={educationClassesFilterFields}
          onFilterChange={onFilterChange}
          siderClassName={styles.sider}
        />
        <TableColumnsFilter columns={allColumns} onColumnsChange={onColumnsChange} />
      </AppFlex>

      <Table
        dataSource={educationClasses}
        columns={displayedColumns}
        loading={isLoading}
        rowKey="id"
        onChange={onTableChange}
        pagination={pagination}
        bordered
      />
    </>
  );
};
